import React from 'react';

const Spinner = () => (
  <React.Fragment>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
    <div
      style={{
        border: '2px solid #f3f3f3',
        borderTop: '2px solid #333',
        borderRadius: '50%',
        width: '16px',
        height: '16px',
        animation: 'spin 1s linear infinite',
      }}
    />
  </React.Fragment>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/containers/client/Spinner.js